/* ==========================================================================
   Atelier — theme.js
   ========================================================================== */
(function () {
  'use strict';

  var settings = window.themeSettings || {};
  var locales = settings.locales || {};

  /* --- Utilities --------------------------------------------------------- */

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var moneyFormat = format || settings.moneyFormat || '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = typeof precision === 'undefined' ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }

    switch (moneyFormat.match(placeholderRegex)[1]) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return moneyFormat.replace(placeholderRegex, value);
  }

  function serializeFilterForm(form) {
    var params = new URLSearchParams();
    Array.prototype.forEach.call(form.elements, function (el) {
      if (!el.name || el.disabled) return;
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      if (el.value !== '') params.append(el.name, el.value);
    });
    return params.toString();
  }

  function trapEscape(callback) {
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') callback();
    });
  }

  /* --- Scroll animations --------------------------------------------------- */

  function initAnimations() {
    var items = document.querySelectorAll('.animate-item');
    if (!items.length || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    items.forEach(function (el) { observer.observe(el); });
  }

  /* --- Header ---------------------------------------------------------------- */

  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (header && header.classList.contains('header--sticky')) {
      window.addEventListener('scroll', function () {
        header.classList.toggle('is-scrolled', window.scrollY > 4);
      }, { passive: true });
    }

    // Search drawer
    var searchDrawer = document.getElementById('SearchDrawer');
    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-search-open]');
      var closeBtn = e.target.closest('[data-search-close]');
      if (openBtn && searchDrawer) {
        searchDrawer.hidden = !searchDrawer.hidden;
        openBtn.setAttribute('aria-expanded', String(!searchDrawer.hidden));
        if (!searchDrawer.hidden) {
          var input = searchDrawer.querySelector('input[type="search"]');
          if (input) input.focus();
        }
      }
      if (closeBtn && searchDrawer) searchDrawer.hidden = true;
    });

    // Mobile menu
    var mobileMenu = document.getElementById('MobileMenu');
    function closeMobileMenu() {
      if (!mobileMenu || mobileMenu.hidden) return;
      mobileMenu.classList.remove('is-open');
      document.body.classList.remove('overflow-hidden');
      setTimeout(function () { mobileMenu.hidden = true; }, 300);
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-menu-open]') && mobileMenu) {
        mobileMenu.hidden = false;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { mobileMenu.classList.add('is-open'); });
        });
        document.body.classList.add('overflow-hidden');
      }
      if (e.target.closest('[data-menu-close]')) closeMobileMenu();
    });
    trapEscape(function () {
      closeMobileMenu();
      if (searchDrawer) searchDrawer.hidden = true;
    });
  }

  /* --- Cart ---------------------------------------------------------------------- */

  var cartDrawer = null;

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
  }

  function refreshCartDrawer(open) {
    return fetch(window.location.pathname + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .catch(function () {
        return fetch('/?section_id=cart-drawer').then(function (r) { return r.text(); });
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newContent = doc.querySelector('[data-cart-drawer-content]');
        var currentContent = document.querySelector('#CartDrawer [data-cart-drawer-content]');
        if (newContent && currentContent) currentContent.innerHTML = newContent.innerHTML;
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        if (open) openCartDrawer();
        return cart;
      });
  }

  function openCartDrawer() {
    cartDrawer = document.getElementById('CartDrawer');
    if (!cartDrawer) return;
    cartDrawer.hidden = false;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { cartDrawer.classList.add('is-open'); });
    });
    document.body.classList.add('overflow-hidden');
  }

  function closeCartDrawer() {
    if (!cartDrawer || cartDrawer.hidden) return;
    cartDrawer.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    setTimeout(function () { cartDrawer.hidden = true; }, 300);
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: quantity || 1 })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return r.json();
    });
  }

  function changeCartLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    }).then(function (r) { return r.json(); });
  }

  function initCart() {
    cartDrawer = document.getElementById('CartDrawer');
    var isDrawerMode = settings.cartType === 'drawer' && cartDrawer;

    document.addEventListener('click', function (e) {
      // Open cart
      var openBtn = e.target.closest('[data-cart-open]');
      if (openBtn && isDrawerMode) {
        e.preventDefault();
        openCartDrawer();
      }
      // Close cart
      if (e.target.closest('[data-cart-close]')) closeCartDrawer();

      // Quick add
      var quickAdd = e.target.closest('[data-quick-add]');
      if (quickAdd) {
        quickAdd.classList.add('is-loading');
        addToCart(quickAdd.dataset.variantId, 1)
          .then(function () {
            if (isDrawerMode) return refreshCartDrawer(true);
            window.location.href = '/cart';
          })
          .catch(function (err) { alert((err && err.description) || locales.cartError); })
          .finally(function () { quickAdd.classList.remove('is-loading'); });
      }

      // Remove line (drawer)
      var removeBtn = e.target.closest('[data-cart-remove]');
      if (removeBtn) {
        e.preventDefault();
        changeCartLine(removeBtn.dataset.line, 0).then(function () { refreshCartDrawer(false); });
      }

      // Quantity +/- (drawer & cart page)
      var minus = e.target.closest('[data-quantity-minus]');
      var plus = e.target.closest('[data-quantity-plus]');
      if (minus || plus) {
        var btn = minus || plus;
        var wrapper = btn.closest('.quantity-selector');
        var input = wrapper && wrapper.querySelector('[data-quantity-input]');
        if (!input) return;
        var qty = parseInt(input.value, 10) || 0;
        qty = minus ? Math.max(0, qty - 1) : qty + 1;
        input.value = qty;
        if (btn.dataset.line) {
          changeCartLine(btn.dataset.line, qty).then(function () {
            if (document.body.classList.contains('template-cart')) {
              window.location.reload();
            } else {
              refreshCartDrawer(false);
            }
          });
        }
      }
    });

    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-quantity-input]');
      if (input && input.dataset.line) {
        changeCartLine(input.dataset.line, input.value).then(function () {
          if (document.body.classList.contains('template-cart')) {
            window.location.reload();
          } else {
            refreshCartDrawer(false);
          }
        });
      }
      var note = e.target.closest('[data-cart-note]');
      if (note) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: note.value })
        });
      }
    });

    trapEscape(closeCartDrawer);
  }

  /* --- Product form ------------------------------------------------------------------- */

  function initProduct() {
    var productEl = document.querySelector('[data-product]');
    var jsonEl = document.querySelector('[data-product-json]');
    if (!productEl || !jsonEl) return;

    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (err) { return; }

    var form = productEl.querySelector('[data-product-form], form[action*="/cart/add"]');
    var idInput = productEl.querySelector('[data-variant-id]');
    var qtyInput = productEl.querySelector('[data-product-quantity]');
    var formQty = productEl.querySelector('[data-form-quantity]');
    var addButton = productEl.querySelector('[data-add-to-cart]');
    var addButtonText = productEl.querySelector('[data-add-to-cart-text]');
    var priceWrapper = productEl.querySelector('[data-product-price]');
    var picker = productEl.querySelector('[data-variant-picker]');

    // Quantity +/- on product page
    productEl.addEventListener('click', function (e) {
      if (e.target.closest('[data-qty-minus]') && qtyInput) {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      }
      if (e.target.closest('[data-qty-plus]') && qtyInput) {
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
      }
      if (formQty && qtyInput) formQty.value = qtyInput.value;
    });
    if (qtyInput && formQty) {
      qtyInput.addEventListener('change', function () { formQty.value = qtyInput.value; });
    }

    function getSelectedOptions() {
      var selected = [];
      if (!picker) return selected;
      picker.querySelectorAll('.product__option').forEach(function (fieldset) {
        var checked = fieldset.querySelector('input:checked');
        selected.push(checked ? checked.value : null);
      });
      return selected;
    }

    function findVariant(selected) {
      return product.variants.find(function (variant) {
        return selected.every(function (value, index) {
          return variant['option' + (index + 1)] === value;
        });
      });
    }

    function updateMedia(variant) {
      if (!variant || !variant.featured_media) return;
      var mediaId = variant.featured_media.id;
      var target = productEl.querySelector('.product__media-item[data-media-id="' + mediaId + '"]');
      if (!target) return;
      productEl.querySelectorAll('.product__media-item').forEach(function (el) { el.classList.remove('is-active'); });
      target.classList.add('is-active');
      productEl.querySelectorAll('[data-thumbnail]').forEach(function (el) {
        el.classList.toggle('is-active', el.dataset.mediaId === String(mediaId));
      });
    }

    function updateVariantUI(variant) {
      if (!variant) {
        if (addButton) {
          addButton.disabled = true;
          if (addButtonText) addButtonText.textContent = locales.unavailable || 'Unavailable';
        }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (addButton) {
        addButton.disabled = !variant.available;
        if (addButtonText) {
          addButtonText.textContent = variant.available ? (locales.addToCart || 'Add to cart') : (locales.soldOut || 'Sold out');
        }
      }
      if (priceWrapper) {
        var html = '';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html = '<div class="price price--on-sale">' +
            '<span class="price__current price__current--sale">' + formatMoney(variant.price) + '</span>' +
            '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>' +
            '<span class="badge badge--sale">-' + Math.round((1 - variant.price / variant.compare_at_price) * 100) + '%</span>' +
            '</div>';
        } else {
          html = '<div class="price"><span class="price__current">' + formatMoney(variant.price) + '</span></div>';
        }
        priceWrapper.innerHTML = html;
      }
      updateMedia(variant);
      // Update URL
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    if (picker) {
      picker.addEventListener('change', function (e) {
        var input = e.target.closest('[data-option-value]');
        if (!input) return;
        var fieldset = input.closest('.product__option');
        var selectedSpan = fieldset && fieldset.querySelector('[data-selected-value]');
        if (selectedSpan) selectedSpan.textContent = ': ' + input.value;
        updateVariantUI(findVariant(getSelectedOptions()));
      });
    }

    // Thumbnails
    productEl.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-thumbnail]');
      if (!thumb) return;
      var mediaId = thumb.dataset.mediaId;
      productEl.querySelectorAll('.product__media-item').forEach(function (el) {
        el.classList.toggle('is-active', el.dataset.mediaId === mediaId);
      });
      productEl.querySelectorAll('[data-thumbnail]').forEach(function (el) {
        el.classList.toggle('is-active', el === thumb);
      });
    });

    // AJAX add to cart (drawer mode)
    if (form && settings.cartType === 'drawer' && document.getElementById('CartDrawer')) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addButton) addButton.classList.add('is-loading');
        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        addToCart(idInput.value, qty)
          .then(function () { return refreshCartDrawer(true); })
          .catch(function (err) { alert((err && err.description) || locales.cartError); })
          .finally(function () { if (addButton) addButton.classList.remove('is-loading'); });
      });
    }
  }

  /* --- Quick view ------------------------------------------------------------------------ */

  function initQuickView() {
    var modal = document.getElementById('QuickViewModal');
    var content = document.getElementById('QuickViewContent');
    if (!modal || !content) return;

    function closeModal() {
      modal.hidden = true;
      content.innerHTML = '';
      document.body.classList.remove('overflow-hidden');
    }

    function buildQuickView(product) {
      var wrapper = document.createElement('div');
      wrapper.className = 'quick-view';

      var mediaHtml = product.featured_image
        ? '<div class="quick-view__media media media--portrait"><img src="' + product.featured_image + '&width=600" onerror="this.src=\'' + product.featured_image + '\'" alt=""></div>'
        : '<div></div>';

      var optionsHtml = '';
      if (!(product.variants.length === 1 && product.variants[0].title === 'Default Title')) {
        product.options.forEach(function (option, index) {
          optionsHtml += '<div class="form-field"><label>' + option.name + '</label><select data-qv-option data-index="' + index + '">';
          option.values.forEach(function (value) {
            optionsHtml += '<option value="' + value.replace(/"/g, '&quot;') + '">' + value + '</option>';
          });
          optionsHtml += '</select></div>';
        });
      }

      wrapper.innerHTML =
        mediaHtml +
        '<div class="quick-view__info">' +
        '<h2 class="quick-view__title">' + product.title + '</h2>' +
        '<div class="quick-view__price price" data-qv-price></div>' +
        optionsHtml +
        '<button type="button" class="button button--primary button--full" data-qv-add>' + (locales.addToCart || 'Add to cart') + '</button>' +
        '<a href="/products/' + product.handle + '" class="quick-view__link link">' + (locales.viewDetails || 'View full details') + '</a>' +
        '</div>';

      content.appendChild(wrapper);

      var priceEl = wrapper.querySelector('[data-qv-price]');
      var addBtn = wrapper.querySelector('[data-qv-add]');
      var selects = wrapper.querySelectorAll('[data-qv-option]');

      function currentVariant() {
        if (!selects.length) return product.variants[0];
        var selected = Array.prototype.map.call(selects, function (s) { return s.value; });
        return product.variants.find(function (v) {
          return selected.every(function (value, i) { return v.options[i] === value; });
        });
      }

      function render() {
        var variant = currentVariant();
        if (!variant) {
          priceEl.innerHTML = '<span class="price__current">' + (locales.unavailable || 'Unavailable') + '</span>';
          addBtn.disabled = true;
          return;
        }
        var html = '<span class="price__current' + (variant.compare_at_price > variant.price ? ' price__current--sale' : '') + '">' + formatMoney(variant.price) + '</span>';
        if (variant.compare_at_price > variant.price) {
          html += '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>';
        }
        priceEl.innerHTML = html;
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? (locales.addToCart || 'Add to cart') : (locales.soldOut || 'Sold out');
        addBtn.dataset.variantId = variant.id;
      }

      selects.forEach(function (s) { s.addEventListener('change', render); });
      render();

      addBtn.addEventListener('click', function () {
        addBtn.classList.add('is-loading');
        addToCart(addBtn.dataset.variantId, 1)
          .then(function () {
            closeModal();
            if (settings.cartType === 'drawer' && document.getElementById('CartDrawer')) {
              return refreshCartDrawer(true);
            }
            window.location.href = '/cart';
          })
          .catch(function (err) { alert((err && err.description) || locales.cartError); })
          .finally(function () { addBtn.classList.remove('is-loading'); });
      });
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-quick-view]');
      if (trigger) {
        e.preventDefault();
        fetch('/products/' + trigger.dataset.productHandle + '.js')
          .then(function (r) { return r.json(); })
          .then(function (product) {
            content.innerHTML = '';
            buildQuickView(product);
            modal.hidden = false;
            document.body.classList.add('overflow-hidden');
          })
          .catch(function () { alert(locales.quickViewError || 'Unable to load product.'); });
      }
      if (e.target.closest('[data-quick-view-close]')) closeModal();
    });

    trapEscape(closeModal);
  }

  /* --- Slideshow ---------------------------------------------------------------------------- */

  function initSlideshows() {
    document.querySelectorAll('[data-slideshow]').forEach(function (slideshow) {
      var slides = slideshow.querySelectorAll('[data-slide]');
      var dots = slideshow.querySelectorAll('[data-slide-dot]');
      if (slides.length < 2) return;

      var current = 0;
      var timer = null;
      var autoplay = slideshow.dataset.autoplay === 'true';
      var speed = parseInt(slideshow.dataset.autoplaySpeed, 10) || 6000;

      function goTo(index) {
        current = (index + slides.length) % slides.length;
        slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === current); });
        dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === current); });
      }

      function startTimer() {
        if (!autoplay) return;
        stopTimer();
        timer = setInterval(function () { goTo(current + 1); }, speed);
      }
      function stopTimer() { if (timer) clearInterval(timer); }

      var prev = slideshow.querySelector('[data-slide-prev]');
      var next = slideshow.querySelector('[data-slide-next]');
      if (prev) prev.addEventListener('click', function () { goTo(current - 1); startTimer(); });
      if (next) next.addEventListener('click', function () { goTo(current + 1); startTimer(); });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () { goTo(parseInt(dot.dataset.index, 10)); startTimer(); });
      });

      slideshow.addEventListener('mouseenter', stopTimer);
      slideshow.addEventListener('mouseleave', startTimer);

      // Touch swipe
      var startX = null;
      slideshow.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      slideshow.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var diff = e.changedTouches[0].clientX - startX;
        if (Math.abs(diff) > 50) goTo(diff > 0 ? current - 1 : current + 1);
        startX = null;
        startTimer();
      }, { passive: true });

      startTimer();
    });
  }

  /* --- Countdown ---------------------------------------------------------------------------- */

  function initCountdowns() {
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var endDate = new Date(el.dataset.endDate.replace(' ', 'T'));
      if (isNaN(endDate.getTime())) return;

      var daysEl = el.querySelector('[data-countdown-days]');
      var hoursEl = el.querySelector('[data-countdown-hours]');
      var minutesEl = el.querySelector('[data-countdown-minutes]');
      var secondsEl = el.querySelector('[data-countdown-seconds]');

      function pad(n) { return String(n).padStart(2, '0'); }

      function tick() {
        var diff = endDate.getTime() - Date.now();
        if (diff <= 0) {
          el.classList.add('is-finished');
          daysEl.textContent = hoursEl.textContent = minutesEl.textContent = secondsEl.textContent = '00';
          clearInterval(interval);
          return;
        }
        daysEl.textContent = pad(Math.floor(diff / 86400000));
        hoursEl.textContent = pad(Math.floor(diff / 3600000) % 24);
        minutesEl.textContent = pad(Math.floor(diff / 60000) % 60);
        secondsEl.textContent = pad(Math.floor(diff / 1000) % 60);
      }

      var interval = setInterval(tick, 1000);
      tick();
    });
  }

  /* --- Before / after -------------------------------------------------------------------------- */

  function initBeforeAfter() {
    document.querySelectorAll('[data-before-after]').forEach(function (el) {
      var range = el.querySelector('[data-before-after-range]');
      var clip = el.querySelector('[data-before-after-clip]');
      var handle = el.querySelector('[data-before-after-handle]');
      if (!range || !clip || !handle) return;
      range.addEventListener('input', function () {
        var value = range.value;
        clip.style.clipPath = 'inset(0 0 0 ' + value + '%)';
        handle.style.left = value + '%';
      });
    });
  }

  /* --- Collection filters & sorting -------------------------------------------------------------- */

  function initCollection() {
    var filters = document.querySelector('[data-filters]');
    var overlay = document.querySelector('.collection-filters__overlay');

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-filters-open]') && filters) {
        filters.classList.add('is-open');
        if (overlay) overlay.classList.add('is-open');
        document.body.classList.add('overflow-hidden');
      }
      if (e.target.closest('[data-filters-close]')) {
        if (filters) filters.classList.remove('is-open');
        if (overlay) overlay.classList.remove('is-open');
        document.body.classList.remove('overflow-hidden');
      }
    });

    var filtersForm = document.querySelector('[data-filters-form]');
    if (filtersForm) {
      filtersForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var query = serializeFilterForm(filtersForm);
        window.location.href = filtersForm.action + (query ? '?' + query : '');
      });
    }

    var sortSelect = document.querySelector('[data-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        window.location.href = url.toString();
      });
    }
  }

  /* --- Addresses page -------------------------------------------------------------------------- */

  function initAddresses() {
    var container = document.querySelector('[data-addresses]');
    if (!container) return;

    container.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-address-toggle]');
      if (toggle) {
        var target = document.getElementById(toggle.getAttribute('aria-controls'));
        if (target) {
          target.hidden = !target.hidden;
          toggle.setAttribute('aria-expanded', String(!target.hidden));
        }
      }
      var deleteBtn = e.target.closest('[data-address-delete]');
      if (deleteBtn && !window.confirm(deleteBtn.dataset.confirmMessage || 'Delete this address?')) {
        e.preventDefault();
      }
    });

    // Country / province selectors
    container.querySelectorAll('[data-address-country]').forEach(function (countrySelect) {
      var provinceWrapper = countrySelect.closest('.form-row').querySelector('[data-province-wrapper]');
      var provinceSelect = provinceWrapper && provinceWrapper.querySelector('[data-address-province]');

      function updateProvinces() {
        var option = countrySelect.options[countrySelect.selectedIndex];
        var provinces = [];
        try { provinces = JSON.parse(option.getAttribute('data-provinces') || '[]'); } catch (err) {}
        if (!provinceSelect) return;
        provinceSelect.innerHTML = '';
        if (!provinces.length) {
          provinceWrapper.hidden = true;
          return;
        }
        provinces.forEach(function (p) {
          var opt = document.createElement('option');
          opt.value = p[0];
          opt.textContent = p[1];
          provinceSelect.appendChild(opt);
        });
        var defaultProvince = provinceSelect.dataset.default;
        if (defaultProvince) provinceSelect.value = defaultProvince;
        provinceWrapper.hidden = false;
      }

      var defaultCountry = countrySelect.dataset.default;
      if (defaultCountry) countrySelect.value = defaultCountry;
      countrySelect.addEventListener('change', updateProvinces);
      updateProvinces();
    });
  }

  /* --- Init -------------------------------------------------------------------------- */

  document.addEventListener('DOMContentLoaded', function () {
    initAnimations();
    initHeader();
    initCart();
    initProduct();
    initQuickView();
    initSlideshows();
    initCountdowns();
    initBeforeAfter();
    initCollection();
    initAddresses();
  });

  // Re-init inside the Shopify theme editor
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () {
      initAnimations();
      initSlideshows();
      initCountdowns();
      initBeforeAfter();
    });
  }
})();

/* ==========================================================================
   v1.1 — Premium features
   ========================================================================== */
(function () {
  'use strict';

  var settings = window.themeSettings || {};
  var locales = settings.locales || {};

  function formatMoneySimple(cents) {
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var moneyFormat = settings.moneyFormat || '${{amount}}';
    var precision = moneyFormat.indexOf('no_decimals') > -1 ? 0 : 2;
    var useComma = moneyFormat.indexOf('comma_separator') > -1;
    var number = (cents / 100).toFixed(precision);
    var parts = number.split('.');
    var thousands = useComma ? '.' : ',';
    var decimal = useComma ? ',' : '.';
    var out = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands) + (parts[1] ? decimal + parts[1] : '');
    return moneyFormat.replace(placeholderRegex, out);
  }

  /* --- Wishlist ------------------------------------------------------------ */

  var WISHLIST_KEY = 'atelier_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) { return []; }
  }
  function saveWishlist(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function updateWishlistUI() {
    var list = getWishlist();
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = list.length;
      el.classList.toggle('is-empty', list.length === 0);
    });
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var inList = list.indexOf(btn.dataset.productHandle) > -1;
      btn.classList.toggle('is-in-wishlist', inList);
      var label = btn.querySelector('[data-wishlist-label]');
      if (label) label.textContent = inList ? (locales.wishlistRemove || 'Remove from wishlist') : (locales.wishlistAdd || 'Add to wishlist');
    });
  }

  function initWishlist() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();
      var handle = btn.dataset.productHandle;
      var list = getWishlist();
      var index = list.indexOf(handle);
      if (index > -1) { list.splice(index, 1); } else { list.push(handle); }
      saveWishlist(list);
      updateWishlistUI();
      renderWishlistPage();
    });
    updateWishlistUI();
    renderWishlistPage();
  }

  function renderWishlistPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    var emptyEl = document.querySelector('[data-wishlist-empty]');
    if (!grid) return;
    var list = getWishlist();
    grid.innerHTML = '';
    if (emptyEl) emptyEl.hidden = list.length > 0;
    if (!list.length) return;

    list.forEach(function (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function (product) {
          var card = document.createElement('div');
          card.className = 'product-card is-visible';
          var img = product.featured_image
            ? '<img class="product-card__image" src="' + product.featured_image + '" alt="" loading="lazy">'
            : '';
          card.innerHTML =
            '<div class="product-card__media-wrapper">' +
            '<a href="' + product.url + '" class="product-card__link"><div class="product-card__media media media--portrait">' + img + '</div></a>' +
            '<button type="button" class="product-card__wishlist is-in-wishlist" data-wishlist-toggle data-product-handle="' + handle + '" aria-label="' + (locales.wishlistRemove || 'Remove') + '">' +
            '<span class="wishlist-icon-filled"><svg class="icon" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 21S3 14.5 3 8.8C3 5.6 5.5 3.5 8 3.5c1.8 0 3.2 1 4 2.4.8-1.4 2.2-2.4 4-2.4 2.5 0 5 2.1 5 5.3C21 14.5 12 21 12 21Z"/></svg></span>' +
            '</button></div>' +
            '<div class="product-card__info">' +
            '<h3 class="product-card__title"><a href="' + product.url + '">' + product.title + '</a></h3>' +
            '<div class="price"><span class="price__current">' + formatMoneySimple(product.price) + '</span></div>' +
            '</div>';
          grid.appendChild(card);
        })
        .catch(function () {});
    });
  }

  /* --- Predictive search ------------------------------------------------------ */

  function initPredictiveSearch() {
    var drawer = document.getElementById('SearchDrawer');
    var results = document.querySelector('[data-predictive-search-results]');
    if (!drawer || !results) return;
    var input = drawer.querySelector('input[type="search"]');
    var listEl = results.querySelector('[data-predictive-search-list]');
    var viewAll = results.querySelector('[data-predictive-search-view-all]');
    var debounceTimer;

    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      var query = input.value.trim();
      if (query.length < 2) { results.hidden = true; return; }
      debounceTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            listEl.innerHTML = '';
            if (!products.length) { results.hidden = true; return; }
            products.forEach(function (p) {
              var li = document.createElement('li');
              var img = p.featured_image && p.featured_image.url
                ? '<img src="' + p.featured_image.url + '" alt="" loading="lazy" width="52" height="52">'
                : '';
              li.innerHTML = '<a href="' + p.url + '" class="predictive-search__item">' + img +
                '<span><span class="predictive-search__item-title">' + p.title + '</span>' +
                '<span class="predictive-search__item-price">' + (p.price ? formatMoneySimple(Math.round(parseFloat(p.price) * 100)) : '') + '</span></span></a>';
              listEl.appendChild(li);
            });
            if (viewAll) viewAll.href = '/search?q=' + encodeURIComponent(query);
            results.hidden = false;
          })
          .catch(function () { results.hidden = true; });
      }, 250);
    });
  }

  /* --- Sticky add to cart + variant sync --------------------------------------- */

  function initStickyAtc() {
    var bar = document.querySelector('[data-sticky-atc]');
    var buyArea = document.querySelector('.product__buy');
    if (!bar || !buyArea) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
          bar.hidden = false;
          requestAnimationFrame(function () { bar.classList.add('is-visible'); });
        } else {
          bar.classList.remove('is-visible');
        }
      });
    }, { threshold: 0 });
    observer.observe(buyArea);

    var stickyButton = bar.querySelector('[data-sticky-atc-button]');
    if (stickyButton) {
      stickyButton.addEventListener('click', function () {
        var realButton = document.querySelector('[data-add-to-cart]');
        if (realButton && !realButton.disabled) realButton.click();
      });
    }
  }

  function initVariantSync() {
    var productEl = document.querySelector('[data-product]');
    var jsonEl = document.querySelector('[data-product-json]');
    if (!productEl || !jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var inventory = null;
    var invEl = document.querySelector('[data-inventory-json]');
    if (invEl) { try { inventory = JSON.parse(invEl.textContent); } catch (e) {} }

    var picker = productEl.querySelector('[data-variant-picker]');
    if (!picker) return;

    picker.addEventListener('change', function () {
      var selected = [];
      picker.querySelectorAll('.product__option').forEach(function (fieldset) {
        var checked = fieldset.querySelector('input:checked');
        selected.push(checked ? checked.value : null);
      });
      var variant = product.variants.find(function (v) {
        return selected.every(function (value, i) { return v['option' + (i + 1)] === value; });
      });
      if (!variant) return;

      // Sticky bar
      var stickyPrice = document.querySelector('[data-sticky-atc-price]');
      var stickyButton = document.querySelector('[data-sticky-atc-button]');
      if (stickyPrice) stickyPrice.textContent = formatMoneySimple(variant.price);
      if (stickyButton) {
        stickyButton.disabled = !variant.available;
        stickyButton.textContent = variant.available ? (locales.addToCart || 'Add to cart') : (locales.soldOut || 'Sold out');
      }

      // Low stock
      var lowStock = document.querySelector('[data-low-stock]');
      if (lowStock && inventory) {
        var qty = inventory.variants[String(variant.id)];
        var textEl = lowStock.querySelector('[data-low-stock-text]');
        if (qty !== null && qty !== undefined && qty > 0 && qty <= inventory.threshold) {
          if (textEl) textEl.textContent = (inventory.lowStockText || '').replace('[[count]]', qty);
          lowStock.hidden = false;
        } else {
          lowStock.hidden = true;
        }
      }
    });
  }

  /* --- Video ------------------------------------------------------------------ */

  function getEmbedUrl(url) {
    var youtube = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{11})/);
    if (youtube) return 'https://www.youtube.com/embed/' + youtube[1] + '?autoplay=1&rel=0';
    var vimeo = url.match(/vimeo\.com\/(\d+)/);
    if (vimeo) return 'https://player.vimeo.com/video/' + vimeo[1] + '?autoplay=1';
    return null;
  }

  function initVideo() {
    document.addEventListener('click', function (e) {
      var play = e.target.closest('[data-video-play]');
      if (!play) return;
      var wrapper = play.closest('[data-video-external]');
      if (!wrapper) return;
      var embed = getEmbedUrl(wrapper.dataset.videoUrl || '');
      if (!embed) return;
      var iframe = document.createElement('iframe');
      iframe.src = embed;
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;
      wrapper.appendChild(iframe);
      play.remove();
    });
  }

  /* --- Lookbook hotspots ------------------------------------------------------- */

  function initLookbook() {
    document.addEventListener('click', function (e) {
      var dot = e.target.closest('[data-hotspot-toggle]');
      if (dot) {
        var hotspot = dot.closest('.lookbook__hotspot');
        var popup = hotspot.querySelector('.lookbook__popup');
        var wasOpen = !popup.hidden;
        document.querySelectorAll('.lookbook__popup').forEach(function (p) { p.hidden = true; });
        document.querySelectorAll('.lookbook__hotspot').forEach(function (h) { h.classList.remove('is-open'); });
        if (!wasOpen) {
          popup.hidden = false;
          hotspot.classList.add('is-open');
          dot.setAttribute('aria-expanded', 'true');
        }
        return;
      }
      if (!e.target.closest('.lookbook__popup')) {
        document.querySelectorAll('.lookbook__popup').forEach(function (p) { p.hidden = true; });
        document.querySelectorAll('.lookbook__hotspot').forEach(function (h) { h.classList.remove('is-open'); });
      }
    });
  }

  /* --- Init ---------------------------------------------------------------------- */

  document.addEventListener('DOMContentLoaded', function () {
    initWishlist();
    initPredictiveSearch();
    initStickyAtc();
    initVariantSync();
    initVideo();
    initLookbook();
  });
})();

/* ==========================================================================
   Zoom lightbox, size guide, dynamic product recommendations
   ========================================================================== */
(function () {
  'use strict';

  var locales = (window.themeSettings || {}).locales || {};

  /* --- Lightbox ------------------------------------------------------------ */

  function initLightbox() {
    var lightbox = document.querySelector('[data-lightbox]');
    var gallery = document.querySelector('[data-zoom-gallery]');
    if (!lightbox || !gallery) return;

    var imageEl = lightbox.querySelector('[data-lightbox-image]');
    var counterEl = lightbox.querySelector('[data-lightbox-counter]');
    var sources = [];
    var index = 0;

    function collect() {
      sources = Array.prototype.slice
        .call(gallery.querySelectorAll('.product__media-item img'))
        .map(function (img) {
          var src = img.currentSrc || img.src;
          return { src: src.replace(/(\?|&)width=\d+/, '$1width=1800'), alt: img.alt || '' };
        });
    }

    function show(i) {
      if (!sources.length) return;
      index = (i + sources.length) % sources.length;
      imageEl.src = sources[index].src;
      imageEl.alt = sources[index].alt;
      if (counterEl) {
        counterEl.textContent = sources.length > 1 ? (index + 1) + ' / ' + sources.length : '';
      }
    }

    function open(startIndex) {
      collect();
      if (!sources.length) return;
      show(startIndex || 0);
      lightbox.hidden = false;
      document.body.classList.add('overflow-hidden');
      var closeBtn = lightbox.querySelector('[data-lightbox-close]');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      lightbox.hidden = true;
      document.body.classList.remove('overflow-hidden');
    }

    gallery.addEventListener('click', function (e) {
      if (e.target.closest('[data-zoom-open]') || e.target.matches('.product__media-item img')) {
        var active = gallery.querySelector('.product__media-item.is-active');
        var items = Array.prototype.slice.call(gallery.querySelectorAll('.product__media-item'));
        open(Math.max(0, items.indexOf(active)));
      }
    });

    lightbox.addEventListener('click', function (e) {
      if (e.target.closest('[data-lightbox-close]') || e.target === imageEl) return close();
      if (e.target.closest('[data-lightbox-prev]')) return show(index - 1);
      if (e.target.closest('[data-lightbox-next]')) return show(index + 1);
    });

    document.addEventListener('keydown', function (e) {
      if (lightbox.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(index - 1);
      if (e.key === 'ArrowRight') show(index + 1);
    });

    var touchX = null;
    lightbox.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
    lightbox.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var diff = e.changedTouches[0].clientX - touchX;
      if (Math.abs(diff) > 50) show(diff > 0 ? index - 1 : index + 1);
      touchX = null;
    }, { passive: true });
  }

  /* --- Size guide ---------------------------------------------------------- */

  function initSizeChart() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-size-chart-open]');
      if (opener) {
        var modal = document.getElementById(opener.getAttribute('aria-controls'));
        if (modal) {
          modal.hidden = false;
          opener.setAttribute('aria-expanded', 'true');
          document.body.classList.add('overflow-hidden');
        }
        return;
      }
      var closer = e.target.closest('[data-size-chart-close]');
      if (closer) {
        var openModal = closer.closest('.size-chart__modal');
        if (openModal) {
          openModal.hidden = true;
          document.body.classList.remove('overflow-hidden');
          var trigger = openModal.parentElement.querySelector('[data-size-chart-open]');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        }
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.size-chart__modal:not([hidden])').forEach(function (modal) {
        modal.hidden = true;
        document.body.classList.remove('overflow-hidden');
      });
    });
  }

  /* --- Product recommendations ---------------------------------------------
     The section already contains server-rendered products (same collection), so
     search engines and no-JS visitors always see links. This only upgrades them
     to Shopify's personalised recommendations.                                */

  function initRecommendations() {
    var section = document.querySelector('[data-product-recommendations]');
    if (!section || !section.dataset.url) return;

    function load() {
      section.classList.add('is-loading');
      fetch(section.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-product-recommendations]');
          var grid = fresh && fresh.querySelector('.product-grid');
          if (grid && grid.children.length) {
            var current = section.querySelector('.product-grid');
            if (current) current.innerHTML = grid.innerHTML;
          }
        })
        .catch(function () { /* keep the server-rendered fallback */ })
        .finally(function () { section.classList.remove('is-loading'); });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { observer.disconnect(); load(); }
      }, { rootMargin: '400px' });
      observer.observe(section);
    } else {
      load();
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initLightbox();
    initSizeChart();
    initRecommendations();
  });
})();
